<template>
  <section class="app-main" :class="{ 'jl-detail-route': isDetailPage }">
    <!-- 页面标题区域 -->
    <div class="page-header" v-if="$route.meta && $route.meta.title">
      <h1 class="page-title">{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index">
          <span>{{ item.meta && item.meta.title }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <!-- 主体内容 -->
    <div class="page-content">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    breadcrumbs() {
      return this.$route.matched.filter(route => route.meta && route.meta.title);
    },
    isDetailPage() {
      const routeTitle = (this.$route.meta && this.$route.meta.title) || '';
      const routeName = String(this.$route.name || '');
      const detailRouteNames = ['customerProfilingListContractSettlement'];

      return /详情|Detail/i.test(`${routeTitle} ${routeName}`) || detailRouteNames.includes(routeName);
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-main {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  animation: fadeIn 0.22s ease-out;
}

/* 页面标题区域 */
.page-header {
  display: flex;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 14px;
  padding: 14px 18px;
  border: 1px solid #e5eaf2;
  border-radius: 12px;
  background: linear-gradient(120deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 4px 18px rgba(31, 68, 135, 0.035);
}

.page-title {
  flex: 0 1 auto;
  min-width: 0;
  margin: 0;
  padding-left: 38px;
  color: #172033;
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  position: relative;
}

.page-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #eff6ff;
  box-shadow: inset 0 0 0 1px #dce8fb;
}

.page-title::after {
  content: '';
  position: absolute;
  left: 10px;
  top: 50%;
  width: 8px;
  height: 8px;
  border: 2px solid #2563eb;
  border-radius: 3px;
  transform: translateY(-50%) rotate(45deg);
}

.page-breadcrumb {
  flex: 0 1 auto;
  min-width: 0;
  color: #68758a;
  font-size: 12px;
}

.page-breadcrumb :deep(.el-breadcrumb__inner) {
  font-weight: 400;
  color: #68758a;
  cursor: default;
}

.page-breadcrumb :deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
  color: #435168;
  font-weight: 600;
}

/* 页面内容 */
.page-content {
  background: transparent;
  border-radius: 12px;
  padding: 0;
  min-height: 400px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

@media (max-width: 768px), (max-width: 960px) and (max-height: 540px) and (orientation: landscape) {
  .page-header {
    min-height: 0;
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 16px;
    padding: 13px 14px;
  }

  .page-title {
    font-size: 18px;
    line-height: 26px;
  }

  .page-breadcrumb {
    line-height: 20px;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .page-content {
    min-height: 280px;
  }
}

/* 路由切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue